import { render, staticRenderFns } from "./awardList.vue?vue&type=template&id=05934de4&scoped=true&"
import script from "./awardList.vue?vue&type=script&lang=js&"
export * from "./awardList.vue?vue&type=script&lang=js&"
import style0 from "./awardList.vue?vue&type=style&index=0&id=05934de4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05934de4",
  null
  
)

export default component.exports